import NoRecordsIcon from '@assets/icons/no-records-datatable.svg';
import { Text } from '@components/v2/ui';
import { MeasurabilityOffsetProjectCard } from '@components/v2/ui/MeasurabilityOffsetProjectCard';
import { Pagination } from '@components/v2/ui/Pagination';
import { ProjectCardSkeleton } from '@components/v2/ui/ProjectCard/ProjectCardSkeleton';
import { NOT_APPLICABLE } from '@config/constants/common';
import { useMesurabilityProjects } from '@features/offsets/api/get-mesurability-projects';
import { useOffsetProjectMesurability } from '@features/offsets/hooks/useOffsetProjectMesurability';
import {
	ActionIcon,
	Badge,
	Box,
	Flex,
	Image,
} from '@mantine/core';
import {
	useDisclosure,
	useMediaQuery,
} from '@mantine/hooks';
import useStore from '@store/index';
import { IconFilter } from '@tabler/icons-react';
import { AnimatePresence, motion } from 'framer-motion';
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ContributionProgressBar from '../../ContributionProgressBar/ContributionProgressBar';
import MeasurabilitiesOffsetSummaryCart from '../../MeasurabilitiesOffsetSummaryCart/MeasurabilitiesOffsetSummaryCart';
import classes from '../CreateOffset.module.css';
import { Filter } from './Filter';

const Step2 = () => {
	const [
		openedFilters,
		{ open: openFilters, close: closeFilters },
	] = useDisclosure(false);

	const {
		currentStepOffsetCreate,
		offsetCreationDatas,
		setOffsetMesurabilityProjectsPage,
		setOffsetMesurabilityProjectsPageSize,
		offsetMesurabilityProjectsPage,
		offsetMesurabilityProjectsPageSize,
		offsetMesurabilityProjectsQueryParams,
		offsetMesurabilityProjects,
		offsetMesurabilityProjectsSelected,
		setOffsetMesurabilityProjects,
	} = useStore();

	const {
		data: offsetsMesurabilityProjectsApi,
		isLoading,
		total: totalItems,
		totalPages,
		isRefetching,
		isFetched,
	} = useMesurabilityProjects(
		offsetMesurabilityProjectsPage,
		offsetMesurabilityProjectsPageSize as number,
		offsetMesurabilityProjectsQueryParams
	);

	const {
		isSelectedProjectMesurability,
		handleOnChangeTco2,
		handleRemoveSelectedProject,
	} = useOffsetProjectMesurability();

	const { t } = useTranslation();
	useEffect(() => {
		if (isRefetching && offsetsMesurabilityProjectsApi) {
			const _cloneOffsetMesurabilityProjects = JSON.parse(
				JSON.stringify(
					offsetsMesurabilityProjectsApi,
					null,
					2
				)
			);
			const _cloneOffsetMesurabilityProjectsSelected =
				JSON.parse(
					JSON.stringify(
						offsetMesurabilityProjectsSelected,
						null,
						2
					)
				);

			const newOffsetMesurabilityProjects =
				_cloneOffsetMesurabilityProjects.map(
					(objet1: any) => {
						const objet2Correspondant =
							_cloneOffsetMesurabilityProjectsSelected.find(
								(objet2: any) => objet2.id === objet1.id
							);
						if (objet2Correspondant) {
							return {
								...objet1,
								quantitytco2eq:
									objet2Correspondant.quantitytco2eq,
							};
						} else {
							return objet1;
						}
					}
				);

			setOffsetMesurabilityProjects(
				newOffsetMesurabilityProjects
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isRefetching]);

	useEffect(() => {
		if (
			isFetched &&
			!isRefetching &&
			offsetsMesurabilityProjectsApi
		) {
			setOffsetMesurabilityProjects(
				offsetsMesurabilityProjectsApi
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isFetched]);

	useEffect(() => {
		if (
			offsetMesurabilityProjectsSelected &&
			offsetMesurabilityProjectsSelected.length == 0
		) {
			//setOffsetStep2Error(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [offsetMesurabilityProjectsSelected]);

	useEffect(() => {
		window.scrollTo({ top: 0 });
	}, [currentStepOffsetCreate]);

	const isMobile = useMediaQuery('(max-width: 868px)');

	return (
		<Box mt={'48px'}>
			<Filter
				opened={openedFilters}
				onClose={closeFilters}
				title={t('filters.titles.projects')}
				onApplyFilters={(filters) => {}}
				value={offsetMesurabilityProjectsQueryParams}
			/>
			<Flex
				direction={isMobile ? 'column-reverse' : 'row'}
				gap={'24px'}
			>
				<Box w={'100%'}>
					<Flex
						justify={'space-between'}
						align={'center'}
						mb={'xs'}
					>
						<ContributionProgressBar
							total={offsetCreationDatas?.quantity ?? 0}
							allocated={offsetMesurabilityProjectsSelected.reduce(
								(acc, item) =>
									acc +
									(Number(item.quantitytco2eq) || 0),
								0
							)}
						/>
						<div
							style={{
								position: 'relative',
							}}
						>
							{Object.keys(
								offsetMesurabilityProjectsQueryParams
							).length > 0 && (
								<Badge
									style={{
										position: 'absolute',
										zIndex: '3',
										right: '-3px',
										fontFamily: 'InterDisplay-Regular',
									}}
									color="var(--mantine-color-igluRed-9)"
									size="xs"
									circle
									bg={
										!isEmpty(
											offsetMesurabilityProjectsQueryParams
										)
											? 'var(--mantine-color-igluRed-9)'
											: 'transparent'
									}
								>
									{
										Object.keys(
											offsetMesurabilityProjectsQueryParams
										).length
									}
								</Badge>
							)}

							<ActionIcon
								size="48px"
								radius="xl"
								color="var(--mantine-color-igluBorder-9)"
								variant="outline"
								data-testid="bell-icon-button"
								onClick={openFilters}
								bg={
									!isEmpty(
										offsetMesurabilityProjectsQueryParams
									)
										? 'var(--mantine-color-igluPrimary-9)'
										: 'transparent'
								}
							>
								<IconFilter
									radius="xl"
									size={24}
									stroke={1.5}
									color={
										!isEmpty(
											offsetMesurabilityProjectsQueryParams
										)
											? 'var(--mantine-color-igluTextButton-9)'
											: 'var(--mantine-color-igluPrimary-9)'
									}
								/>
							</ActionIcon>
						</div>
					</Flex>

					<Box
						style={{
							display: 'grid',
							gridTemplateColumns: isMobile
								? '1fr'
								: 'repeat(auto-fill, minmax(300px, 1fr))',
							gap: 'var(--mantine-spacing-sm)',
						}}
					>
						{isLoading
							? [...Array(10).keys()].map(
									(project, index) => (
										<AnimatePresence
											key={index}
											mode="wait"
										>
											<motion.div
												key={'empty'}
												initial={{
													y: 10,
													opacity: 0,
												}}
												animate={{
													y: 0,
													opacity: 1,
												}}
												exit={{
													y: -10,
													opacity: 0,
												}}
												transition={{
													duration: 0.2,
												}}
												style={{
													display: 'flex',
													flex: 1,
												}}
											>
												<ProjectCardSkeleton
													fullWidth={true}
												/>
											</motion.div>
										</AnimatePresence>
									)
								)
							: !isLoading &&
								Array.isArray(
									offsetMesurabilityProjects
								) &&
								offsetMesurabilityProjects.length > 0 &&
								offsetMesurabilityProjects.map(
									(project) => {
										const remainingQuantity =
											(offsetCreationDatas?.quantity ??
												0) -
											offsetMesurabilityProjectsSelected.reduce(
												(acc, item) =>
													acc +
													(Number(item.quantitytco2eq) ||
														0),
												0
											);

										const isAlreadySelected =
											isSelectedProjectMesurability(
												project.id,
												offsetMesurabilityProjectsSelected
											);

										const disableNumberInput =
											!isAlreadySelected &&
											(remainingQuantity === 0 ||
												offsetMesurabilityProjectsSelected.length >=
													4);
										return (
											<AnimatePresence
												key={project.id}
												mode="wait"
											>
												<motion.div
													key={project.id}
													initial={{
														y: 10,
														opacity: 0,
													}}
													animate={{
														y: 0,
														opacity: 1,
													}}
													exit={{
														y: -10,
														opacity: 0,
													}}
													transition={{
														duration: 0.2,
													}}
													style={{
														display: 'flex',
														flex: 1,
													}}
												>
													<MeasurabilityOffsetProjectCard
														remainingQuantity={
															remainingQuantity
														}
														disableNumberInput={
															disableNumberInput
														}
														quantity={
															project.quantitytco2eq
														}
														disabled={project.isDisabled}
														disabledLabel={t(
															'offsets.projectLacksQte'
														)}
														key={project.id}
														cover={project?.image}
														type="measurability"
														projectType={project?.type}
														name={project?.name}
														active={project?.active}
														fullWidth={true}
														supportedByLogo={
															project?.supportedBy
														}
														location={{
															countryCode:
																project?.country?.code ||
																NOT_APPLICABLE,
															place:
																project?.location
																	?.place ||
																NOT_APPLICABLE,
															countryName:
																project?.country?.name ||
																NOT_APPLICABLE,
														}}
														onStatusChange={async () => {}}
														availableStock={
															project?.tokenAvailable ?? 0
														}
														sellPrice={
															project.sellPrice_europertco2eq ||
															0
														}
														onClick={() => {}}
														showStatus={true}
														readonly={true}
														onChangeQuantity={(tco2) => {
															handleOnChangeTco2(
																project,
																tco2
															);
														}}
														isAdded={isSelectedProjectMesurability(
															project.id,
															offsetMesurabilityProjectsSelected
														)}
													/>
												</motion.div>
											</AnimatePresence>
										);
									}
								)}
					</Box>

					{!isLoading &&
						Array.isArray(offsetMesurabilityProjects) &&
						offsetMesurabilityProjects.length == 0 && (
							<Box className={classes.containerEmptyList}>
								<Box
									className={
										classes.containerTextsNoRecords
									}
								>
									<Image
										src={NoRecordsIcon}
										className={classes.iconNoRecords}
									/>
									<>
										<Text
											className={classes.titleNoRecords}
											variant="subtitle1"
											c="var(--mantine-color-igluPrimary-9)"
										>
											{t(
												'global.datatable.noResultsFound'
											)}
										</Text>
										<Text
											className={
												classes.descriptionNoRecords
											}
											variant="body2"
										>
											{t(
												'global.datatable.noResultsFoundDescription'
											)}
										</Text>
									</>
								</Box>
							</Box>
						)}
				</Box>
				<MeasurabilitiesOffsetSummaryCart
					items={offsetMesurabilityProjectsSelected}
					onRemove={handleRemoveSelectedProject}
				/>
			</Flex>
			<Box mt={'24px'}>
				<Pagination
					pageSize={
						offsetMesurabilityProjectsPageSize
							? (offsetMesurabilityProjectsPageSize as number)
							: 0
					}
					totalItems={totalItems}
					activePage={offsetMesurabilityProjectsPage}
					onPageSizeChange={function (
						_size: string | number
					) {
						setOffsetMesurabilityProjectsPageSize(_size);
						setOffsetMesurabilityProjectsPage(1);
					}}
					onChange={(data) => {
						setOffsetMesurabilityProjectsPage(data);
					}}
					total={totalPages ? totalPages : 0}
				/>
			</Box>
		</Box>
	);
};

export default Step2;
